























import { Component, PropSync, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import {FormRowWings, InputWings} from "wings-ui-components";

@Component({components: {FormRowWings, InputWings}})
export default class SaveTemplateDialog extends Vue {
  @Ref('validator') validator:any;
  @PropSync('show') active!: boolean;
  @Prop() error!: any

  name = null
  templateName = null

  @Watch('error', {immediate: true})
  onError(error: any) {
    this.templateName = this.name
  }

  async onConfirm() {
    if (!await this.validator.validate()) {
      return
    }
    this.$emit('save', this.name)
  }

}
